'use es6';

export const getTrackingAssociationType = associationOption => {
  if (
  // eslint-disable-next-line no-prototype-builtins
  !associationOption.hasOwnProperty('isPublicPrimary') ||
  // eslint-disable-next-line no-prototype-builtins
  !associationOption.hasOwnProperty('isWildcard')) {
    return undefined;
  }
  if (associationOption.isPublicPrimary) {
    return 'primary';
  }
  if (associationOption.isWildcard) {
    return 'all';
  }
  return 'label';
};